import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { store } from './app/store';
import { queryClient } from './app/queryClient';
import { router } from './app/router';
import { registerGlobalHandlers, bootstrapSession } from './app/globalHandlers';
import './index.css';

// Cross-cutting listeners (session expiry, plan limits) — registered once,
// before render, so no event fired during startup is missed.
registerGlobalHandlers(store, queryClient);

// Refresh permissions/identity from the server on load, so a returning user
// never has to re-login after their role grants change. Runs in the background;
// the UI renders immediately from the hydrated session.
bootstrapSession(store);

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

createRoot(rootEl).render(
  <StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        {/* v7_startTransition wraps navigation state updates in
            React.startTransition, so navigating to a lazy() route that suspends
            keeps the current screen until the chunk loads instead of throwing
            "A component suspended while responding to synchronous input" (hit on
            the post-login navigate into the lazy DashboardPage). */}
        <RouterProvider router={router} future={{ v7_startTransition: true }} />
      </QueryClientProvider>
    </Provider>
  </StrictMode>,
);
